import React from "react";

const TestimonialGrid = ({ testimonials }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4">
      {testimonials.map((t, index) => (
        <div key={index} className="card bg-white shadow-md">
          <div className="card-body">
            <div className="flex items-center justify-between mb-2">
              <h2 className="card-title text-lg font-semibold">{t.name}</h2>
              <div className="rating">
                {Array.from({ length: 5 }).map((_, i) => (
                  <input
                    key={i}
                    type="radio"
                    name={`rating-${index}`}
                    className="mask mask-star-2 bg-yellow-500"
                    checked={i < t.rating}
                    readOnly
                  />
                ))}
              </div>
            </div>
            <p className="text-base text-textColor text-justify">
              {t.feedback}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TestimonialGrid;
